module.exports = "./img/1691052225425c82abcbf3e687032a3d.jpg";